/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { finance } from '../models/finance';
import type { FinanceAddedData } from '../models/FinanceAddedData';
import type { FinanceToAddData } from '../models/FinanceToAddData';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FinanceService {
    /**
     * GetFinance
     * @returns finance Общая информация о финансах
     * @throws ApiError
     */
    public static getFinance(): CancelablePromise<finance> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/finance',
        });
    }
    /**
     * Add finance
     * @returns FinanceAddedData Finance added
     * @throws ApiError
     */
    public static addFinance({
        requestBody,
    }: {
        requestBody: FinanceToAddData,
    }): CancelablePromise<FinanceAddedData> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/finance',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Error response`,
                500: `Error response`,
            },
        });
    }
}
